import { motion } from 'framer-motion';

const stackHighlights = [
  {
    category: 'Frontend',
    items: ['React 18', 'TypeScript', 'Tailwind CSS v4', 'Vite', 'Framer Motion']
  },
  {
    category: 'Backend',
    items: ['FastAPI', 'SQLAlchemy', 'Alembic', 'Pydantic', 'OpenAI SDK']
  },
  {
    category: 'Infrastructure',
    items: ['Docker Compose', 'Neon PostgreSQL', 'GitHub Actions', 'Terraform', 'GCP Ready']
  }
];

export function StackOverview() {
  return (
    <section className="py-20 bg-gray-50 border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Everything configured out of the box
            </h2>
            <p className="text-lg text-gray-600">
              Best practices baked in. Start building immediately.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {stackHighlights.map((stack, index) => (
              <StackCard key={stack.category} stack={stack} index={index} />
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}

interface StackCardProps {
  stack: {
    category: string;
    items: string[];
  };
  index: number;
}

function StackCard({ stack, index }: StackCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 + index * 0.1 }}
      className="bg-white rounded-xl border border-gray-200 p-6"
    >
      <h3 className="font-semibold text-gray-900 mb-4">{stack.category}</h3>
      <div className="space-y-2">
        {stack.items.map(item => (
          <div key={item} className="flex items-center gap-2">
            <div className="w-1.5 h-1.5 bg-indigo-600 rounded-full" />
            <span className="text-sm text-gray-600">{item}</span>
          </div>
        ))}
      </div>
    </motion.div>
  );
}